module.exports = window.wp.sync;